var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('montHead'),_c('div',{attrs:{"id":"container"}},[_c('router-view')],1),_c('montFoot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }